<div class="relative">
  <app-button [variant]="variant()" [disabled]="disabled()" [size]="size()" type="button" (click)="toggle()">
    <div [id]="headerID" class="flex items-center gap-1 justify-between rtl:text-right" [attr.aria-expanded]="isOpen()" [attr.aria-controls]="bodyID">
      <ng-content select="label"></ng-content>
      <app-icons icon="chevron-right" class="inline-flex shrink-0 transition-transform duration-300 ease-in-out" [class.rotate-90]="isOpen()"></app-icons>
    </div>
  </app-button>

  <div [id]="bodyID"
       [attr.aria-labelledby]="headerID"
       class="absolute z-10 transition-all duration-200 ease-in-out origin-top-right right-0 bg-neutral-primary-medium border border-default-medium rounded-base shadow-lg w-44"
       [class.opacity-100]="isOpen()"
       [class.opacity-0]="!isOpen()"
       [class.scale-100]="isOpen()"
       [class.scale-95]="!isOpen()"
       [class.pointer-events-none]="!isOpen()">
    <div class="p-2 text-sm text-body font-medium">
      <ng-content></ng-content>
    </div>
  </div>
</div>
